export const MiniQ2ValuesModel = {
    mode: "0",
    time: "360",
    interval: "0",
}
export const MiniQ2HasModel = {
    has_time: false,
    has_interval: false,
}